module.exports = __webpack_public_path__ + "static/media/downloaddisable.f2c79e1e.svg";